import * as routes from 'core/routing/constants'
import * as actions from './actions'

const aStepsConfigurator = [
  {
    hash: routes.CONFIGURATOR_BRANDS,
    isActive: true,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_MODELS_GROUPS,
    isActive: false
  },
  {
    hash: routes.CONFIGURATOR_MODELS,
    isActive: false
  },
  {
    hash: routes.CONFIGURATOR_FINISHES,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_MOTORS,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_DESIGN,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_OPTIONS,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_CONTRACTS,
    isActive: false,
    isStepPrincipal: false
  },
  {
    hash: routes.CONFIGURATOR_CONGRATULATIONS,
    isActive: false,
    isStepPrincipal: false
  },
  {
    hash: routes.CONFIGURATOR_TRADEIN,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_FUNDING,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.CONFIGURATOR_FINALIZATION,
    isActive: false,
    isStepPrincipal: true
  }
]

const aStepsStock = [
  {
    hash: routes.STOCK_VEHICLES_LIST,
    isActive: true,
    isStepPrincipal: true
  },
  {
    hash: routes.STOCK_VEHICLE_DETAIL,
    isActive: false
  },
  {
    hash: routes.STOCK_CONGRATULATIONS,
    isActive: false
  },
  {
    hash: routes.STOCK_TRADEIN,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.STOCK_FUNDING,
    isActive: false,
    isStepPrincipal: true
  },
  {
    hash: routes.STOCK_FINALIZATION,
    isActive: false,
    isStepPrincipal: true
  }
]

export const aStepsTradeIn2 = []

export const aStepsTradeIn1 = [
  {
    hash: routes.TRADEIN_DISTRIBUTOR,
    isActive: true,
    isStepPrincipal: true
  }
]

export const aStepsTheming = [
  {
    hash: routes.THEMING_VIEW_1,
    isActive: true,
    isStepPrincipal: true
  },
  {
    hash: routes.THEMING_VIEW_2,
    isActive: true,
    isStepPrincipal: true
  }
]

export const INITIAL_STATE = {
  activeWizard: null,
  aStepsConfigurator,
  aStepsStock,
  aStepsTradeIn: aStepsTradeIn1,
  aStepsTheming
}

export default function wizardsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.SET_WIZARDS: {
      return action.wizards
    }
    case actions.RESET_CONFIGURATOR_WIZARD: {
      return { ...state, aStepsConfigurator }
    }

    case actions.RESET_TRADEIN_WIZARD: {
      let aStepsTradeIn
      switch (action.tradeInConfig) {
        case 1:
        default:
          aStepsTradeIn = aStepsTradeIn1

          break
        case 2:
          aStepsTradeIn = aStepsTradeIn2

          break
      }
      return { ...state, aStepsTradeIn }
    }
    case actions.RESET_STOCK_WIZARD: {
      return { ...state, aStepsStock }
    }
    default:
      return state
  }
}
